/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_Q4Inputs */

const es_marketplace_seo_galicia_faq_q4 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la mejor época para navegar en Galicia?`)
};

const gl_marketplace_seo_galicia_faq_q4 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cal é a mellor época para navegar en Galicia?`)
};

const en_marketplace_seo_galicia_faq_q4 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the best season to sail in Galicia?`)
};

/**
* | output |
* | --- |
* | "What is the best season to sail in Galicia?" |
*
* @param {Marketplace_Seo_Galicia_Faq_Q4Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_q4 = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_Q4Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_Q4Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_q4(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_q4(inputs)
	return es_marketplace_seo_galicia_faq_q4(inputs)
});